(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WBS-tabbed-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wbs-tab-slider')) {
  customElements.define('wbs-tab-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.root = this.closest('.wbs-tabbed-grid');
      this.track = this.querySelector('[role="tablist"]');
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.root.querySelectorAll('.wbs-tg-panel')];
      this.arrows = [...this.querySelectorAll('[data-tab-direction]')];
      this.mobile = matchMedia('(max-width:749px)');
      this.direction = () => getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      this.activeIndex = () => Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));
      this.update = () => {
        this.classList.toggle('has-tabs', this.tabs.length > 1);
        const index = this.activeIndex();
        this.arrows.forEach(button => {
          button.disabled = this.tabs.length < 2 || (Number(button.dataset.tabDirection) < 0 ? index === 0 : index === this.tabs.length - 1);
        });
      };
      this.reveal = (tab, smooth = true) => {
        if (!tab || !this.mobile.matches) return;
        const target = tab.offsetLeft - (this.track.clientWidth - tab.offsetWidth) / 2;
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.track.scrollTo({left: Math.max(0, Math.min(max, target)), behavior: smooth ? 'smooth' : 'auto'});
      };
      this.select = (tab, focus = false) => {
        if (!tab) return;
        this.tabs.forEach(item => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach(panel => {
          const selected = panel.id === tab.getAttribute('aria-controls');
          panel.classList.toggle('is-active', selected);
          panel.hidden = !selected;
        });
        this.update();
        this.reveal(tab);
        if (focus) tab.focus({preventScroll:true});
      };
      this.step = amount => {
        const next = Math.max(0, Math.min(this.tabs.length - 1, this.activeIndex() + amount));
        if (next !== this.activeIndex()) this.select(this.tabs[next]);
      };
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) this.select(tab);
        const arrow = event.target.closest('[data-tab-direction]');
        if (arrow && this.contains(arrow) && !arrow.disabled) this.step(Number(arrow.dataset.tabDirection));
      }, {signal});
      this.track.addEventListener('keydown', event => {
        const current = this.tabs.indexOf(event.target);
        if (current < 0) return;
        let index;
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.tabs.length - 1;
        else if (event.key === 'ArrowRight') index = (current + this.direction() + this.tabs.length) % this.tabs.length;
        else if (event.key === 'ArrowLeft') index = (current - this.direction() + this.tabs.length) % this.tabs.length;
        else return;
        event.preventDefault();
        this.select(this.tabs[index], true);
      }, {signal});
      this.track.addEventListener('pointerdown', event => {
        if (!this.mobile.matches || !event.isPrimary || event.pointerType === 'mouse') return;
        if (this.track.scrollWidth > this.track.clientWidth + 4) return;
        this.gesture = {id:event.pointerId, x:event.clientX, y:event.clientY};
        this.track.setPointerCapture(event.pointerId);
      }, {signal});
      this.track.addEventListener('pointerup', event => {
        const start = this.gesture;
        this.gesture = null;
        if (!start || event.pointerId !== start.id) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.4) this.step((dx < 0 ? 1 : -1) * this.direction());
      }, {signal});
      this.track.addEventListener('pointercancel', () => { this.gesture = null; }, {signal});
      this.mobile.addEventListener('change', () => {
        this.gesture = null;
        this.track.scrollLeft = 0;
        this.update();
        requestAnimationFrame(() => this.reveal(this.tabs[this.activeIndex()], false));
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        const tab = this.tabs.find(item => item.dataset.blockId === event.detail?.blockId);
        if (tab) this.select(tab);
      }, {signal});
      this.update();
      requestAnimationFrame(() => this.reveal(this.tabs[this.activeIndex()], false));
    }
    disconnectedCallback() { this.abort?.abort(); this.gesture = null; }
  });
}


  } catch(e) { console.error(e); }
})();
})();
